import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-23/task-02";

const task: Slide = {
  title: "Which of the following four circuits is a second-order low-pass filter?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
